export enum EntityStatusEnum {
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  ACTIVATED = 'ACTIVATED',
  REFUSED = 'REFUSED',
  REJECTED = 'REJECTED',
  DEACTIVATED = 'DEACTIVATED',
  MODIFIED = 'MODIFIED',
  NEW = 'NEW',
  WAITING_MODIFICATION_APPROVAL = 'WAITING_MODIFICATION_APPROVAL',
  WAITING_CREATION_APPROVAL = 'WAITING_CREATION_APPROVAL',
  ALL = 'ALL',
  All_Data_without_Deactivated = 'All Data(without Deactivated)',
  
}

export namespace EntityStatusEnum {
  export function getClassName(): string {
    return 'EntityStatusEnum';
  }
}
